import React from 'react'
import classNames from 'classnames'
import { Search, MainHeaderRight } from '..'
import styles from './index.module.less'

export default ({
  wrapStyle = null,
  positionY,
  style = null,
  renderLeftBottom,
  renderRightBottom = null,
  renderLeftTop = null,
}) => {
  return <header className={classNames(styles['mn-header-scroll-wrap'], { [styles.borderBottom]: positionY.current >= 64 })} style={{ ...wrapStyle }}>
    <div className={styles['meinian-header-left']}>
      <div style={{ transform: `translateY(${-positionY.current}px)` }}>
        <div className="meinian-header-left-block">
          {renderLeftTop ? renderLeftTop() : <Search />}
        </div>
        <div className="meinian-header-left-block">
          {renderLeftBottom()}
        </div>
      </div>
    </div>
    <MainHeaderRight style={style} hiddenSearch={positionY.current >= 64}>
      <div className={styles['meinian-header-right-list-switch']} style={{ transform: `translateY(${-positionY.current}px)` }}>
        {renderRightBottom?.()}
      </div>
    </MainHeaderRight>
  </header>
}
